<template>

  <div id="tabViewPopupBox" class="tabViewPopup">
    <div class="tabView-popup-content">
      <div class="tabView-popup-header">
        <span class="tabView_close" v-on:click="closeHelpModal">×</span>
        <h2>Tabular view</h2>
      </div>
      <div class="tabView-popup-main">
        <!-- Names of top-level modules: {{tabViewData.namesOfTopLevelModules}} -->

        <div class="topContainer">
          <div class="downloadOptions">
            <button v-on:click="downloadJSON">Download data as *.json</button>
            <button v-on:click="downloadCSV">Download data as *.csv</button>
          </div>

          <h3>Tabular overview of all nodes</h3>

        </div>

        
        <div>
          This is a hierarchical overview of all nodes and their settings or data content.<br>
          Please click on a node's name to expand the overview, click again to collapse. <br>
          <br>
          To download the currently selected view, please click on one of the buttons in the upper right corner.<br>
          The CSV file is currently not yet well-formatted but provides two rows (one with labels, one with values).
        </div>

        <h4>Select view</h4>

        <div class="menuBar">
          <label for="dataOption">Please choose what to show:</label>
          <select v-model="selectedDataOption" id="dataOption" style="margin-right: 10px; margin-left: 10px; width: auto;">
            <option value="statistics">Statistics</option>
            <option value="parameters">Parameter settings</option>
          </select>
        </div>

        <div class="tableHeader">
          <div style="width: 300px;">Custom Names</div>
          <div style="width: 150px;">Module</div>
          <div style="width: 100px;">Function</div>
          <div style="width: 100px;">Node ID</div>
          <div v-for="period in periods" :key="period" style="width: 100px; text-align: center;">{{period}}</div>
          <div style="width: 100px;"></div> <!-- for average growth; we leave title empty so that it does not show when we show inputs -->
        </div>
      
        <TreeTable 
          v-for="tree in trees"
          :key="tree.nodeUUID"
          :label="tree.label"
          :nodeData="tree.nodeData"
          :nodeParameters="tree.nodeParameters"
          :nodeFunction="tree.nodeFunction"
          :nodeModule="tree.nodeModule"
          :nodeID="tree.nodeID"
          :nodeUUID="tree.nodeUUID"
          :nodeNotInCurrentlyActiveModule="tree.nodeNotInCurrentlyActiveModule"
          :nodeShowStatistics="tree.nodeShowStatistics"
          :nodeAvgGrothRate="tree.nodeAvgGrothRate"
          :nodeTimeType="tree.nodeTimeType"
          :depth="0"
          :nodes="tree.nodes">
        </TreeTable>

      </div>
    </div>
  </div>

</template>


<script>

  import Vue from 'vue';
  import TreeTable from './TreeTable.vue';

  // For computing array stats
  import Array_Average from '../../util/density/Array_Average';
  import Array_Stdev from '../../util/density/Array_Stdev';
  import download from '../../util/download'; // to download data
  
  Vue.component('TreeTable', TreeTable);

  export default {

    name: 'TabView',
    props: ['tabViewData'],
    components: { TreeTable },
    watch: {
      selectedDataOption: function (val, oldVal) {
        // console.log('new: %s, old: %s', val, oldVal);
        // console.log(typeof val) // string
        // console.log(val.substring(1, 4))
        // console.log(val)

        // Prepare data again to reflect changed customer selection
        this.prepareDataForTabularView();
      }
    },
      
    data: () => {
      return {
        selectedDataOption: "statistics", // default
        periods: [],
        treesAsCSVReadyArrayOfRows: [],
        treesAsJSONExport: {},
        trees:[
  /*         {
          treeID: 0,
          label: 'EBITDA %',
          nodeFunction: 'Divide',
          nodeData: [ // each period is one element in the array
            {
              mean: 3
            }
          ],
          nodes: [

            {
              label: 'EBITDA',
              nodeFunction: 'Subtract',
              nodeData: [
                {
                  mean: 3
                }
              ]
            },
            {
              label: 'Revenue',
              nodeFunction: 'Multiply',
              nodeData: [
                {
                  mean: 3
                }
              ]
            }
          ]
        },
        {
          treeID: 1,
          label: 'EBITDA %',
          nodeFunction: 'Divide',
          nodeData: [ // each period is one element in the array
            {
              mean: 3
            }
          ],
          nodes: [

            {
              label: 'EBITDA',
              nodeFunction: 'Subtract',
              nodeData: [
                {
                  mean: 3
                }
              ]
            }
          ]
        } */
      ]
      
      }
    },
    mounted() {
     // console.log('I am mounted!')


      // console.log('this.tabViewData', this.tabViewData)

      // Create the number of periods as an array
      // Then the template can use this as column headers
      for (let i = 0; i < Vue.prototype.$globalSharedData.numberOfPeriods; i++){
        this.periods.push(i+1);
      }

      this.prepareDataForTabularView();

      // This is an event listener for when the user clicks next to the popup.
      // This send sends a signal to not show the popup anymore.
      window.onclick = function(event) {
        let tabViewPopupBox = document.getElementById('tabViewPopupBox');
        if (event.target == tabViewPopupBox) {
          // console.log('Command send to close help.')
          Vue.prototype.$eventHub.$emit("showTabViewPopUpEvent", {showTabView: false});
        }
      }

    },

    methods: {

      // The method below is called when the user clicks the 'x' in the popup.
      // See the v-on:click directive
      closeHelpModal(){
        Vue.prototype.$eventHub.$emit("showTabViewPopUpEvent", {showTabView: false});
      },

      downloadJSON(){

        // csvContent, 'boxplot_data.csv', 'text/csv;charset=utf-8;'
        let json_content = JSON.stringify(this.trees, null, 2);

        download(json_content, `tabular_view_${this.selectedDataOption}.json`, 'text/json;charset=utf-8;')

      },

      downloadCSV(){

        download(this.treesAsCSVReadyArrayOfRows, `tabular_view_${this.selectedDataOption}.csv`, 'text/csv;charset=utf-8;')

      },

      prepareDataForTabularView(){

        // To prevent scope problems below
        let self = this;

        // console.log(this.tabViewData) // we get the name of the currently active module and a dict of nodes to module names

        let nodeToModuleNameDict = this.tabViewData.nodeToModuleNameDict;

        // Reset the tree (so we do not only add tree after tree here with every selection change)
        this.trees = [];


        // console.log(this.tabViewData.data)

        /*****************************************************************************************
          This method prepares the tabViewData so that it can be shown in a tree table
          ----------------------------------------------------------------------------------------
          (a) Using a recursive function, the data is structured hierarchically
          (b) Depending on the option selected by the user, we prepare either stats or parameters
        ******************************************************************************************/

        // Determine which nodes have no _successor_ (which means they themselves are not predecessor to any other node)
        // We do this by adding all node UUIDs to a set that are in predecessor arrays.
        // Then we check which nodes are not in it.
        let setOfNodesWhichArePredecessors = new Set();
        let setOfAllNodes = new Set();

        // console.log('globalNodeData in prepare for TabView', Vue.prototype.$globalSharedData.globalNodeData);

        for (let [key, value] of Object.entries(Vue.prototype.$globalSharedData.globalNodeData)) {
          // console.log(key)
          setOfAllNodes.add(key);
          for (let i = 0; i < value.predecessors.length; i++){
            setOfNodesWhichArePredecessors.add(value.predecessors[i])
          }
        }

        // console.log('setOfNodesWhichArePredecessors', setOfNodesWhichArePredecessors);
        // console.log('setOfAllNodes', setOfAllNodes);

        // Create the difference of both sets: all nodes minus those that are predecessors
        // These are the nodes that have no successor (end nodes)
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set

        let nodesWithoutSuccessors = new Set([...setOfAllNodes].filter(x => !setOfNodesWhichArePredecessors.has(x)))

        // console.log('Nodes with no successor', nodesWithoutSuccessors)


        /*********************************** 
          Prepare CSV file
         ***********************************/

        // The following lines just prepare an array of arrays that can be exported to CSV
        // The first 4 columns are static, the further columns are based on the number of time periods
        let CSVReadyArrayOfArrays = [['name', 'ID', 'UUID', 'module', 'function']]
        let maximumNumberOfParametersInAnyNode = 3;

        if (this.selectedDataOption == 'statistics'){
          // If we show statistics, then all we export at this point is the mean for each period
          for (let i = 0; i < Vue.prototype.$globalSharedData.numberOfPeriods; i++){
            CSVReadyArrayOfArrays[0].push(`mean in period ${i + 1}`)
          }
        } else {
          // If we show parameters, then what we export are the names of 3 parameters
          for (let j = 0; j < maximumNumberOfParametersInAnyNode; j++){
            CSVReadyArrayOfArrays[0].push(`parameter_${j + 1}`)
          }
          // Now we add headers for each parameter and each period
          for (let j = 0; j < maximumNumberOfParametersInAnyNode; j++){
            for (let i = 0; i < Vue.prototype.$globalSharedData.numberOfPeriods; i++){
              CSVReadyArrayOfArrays[0].push(`parameter ${j + 1} in period ${i + 1}`)
            }
          }
        }

        /******************************************************** 
          Recursive function to create a tree of nodes
          ---------------------------------------------
          This function processes exactly one node...
          ...but then calls itself for all input nodes
          This continues until leaf nodes are reached,
          where the first results can be obtained,
          then their results get collected backwards

          We only feed in the UUID of the current node.
          The rest can be pulled from the globalNodeData object, incl. predecessors.
        *********************************************************/


        // Recursive function
        let makeTree = (currentNodeUUID) => {

          // Get the data for this node
          let currentNode = Vue.prototype.$globalSharedData.globalNodeData[currentNodeUUID];

          // This is later the tree structure we pass to the frontend, this may contain HTML
          let node = {};

          // This is later the tree structure we use to export the data as JSON; this does not contain HTML
          let nodeForJSONExport = {};

          // This will be a row in the CSV export
          let csv_row = [];

          // ---------------------------------------------------------------------- 
          // Store all the information about the node we are currently processing
          // ----------------------------------------------------------------------

          // If the node has a title, use that as a label, otherwise default name
          let label = currentNode.nodeData.title ? currentNode.nodeData.title : "(no custom name)";
          node['label'] = label;
          nodeForJSONExport['label'] = label;
          csv_row.push(label);

          let nodeID = currentNode.nodeID;
          node['nodeID'] = nodeID;
          nodeForJSONExport['nodeID'] = nodeID;
          csv_row.push(nodeID);

          // Export UUID as well
          node['nodeUUID'] = currentNodeUUID;
          nodeForJSONExport['UUID'] = currentNodeUUID;
          csv_row.push(currentNodeUUID);

          let nodeModule = nodeToModuleNameDict[currentNode.nodeID];
          node['nodeModule'] = nodeModule;
          nodeForJSONExport['nodeModule'] = nodeModule;
          csv_row.push(nodeModule);

          let nodeFunction = currentNode.nodeFunction;
          node['nodeFunction'] = nodeFunction;
          nodeForJSONExport['nodeFunction'] = nodeFunction;
          csv_row.push(nodeFunction);

          if (this.selectedDataOption == 'statistics'){
            node['nodeShowStatistics'] = true;
          } else {
            node['nodeShowStatistics'] = false;
          }
          
          // For mean etc.
          node['nodeData'] = [];
          nodeForJSONExport['nodeData'] = [];

          // Timetype if the information is available
          let timetype = currentNode.nodeData.timetype ? currentNode.nodeData.timetype : "";
          node['nodeTimeType'] = timetype;

          // For parameter settings
          // Array of periods and then array of objects (key, value pairs)
          node['nodeParameters'] = []
          nodeForJSONExport['nodeParameters'] = []

          // Store in a variable if the module is the currently active one or not
          // console.log('currentModule', this.tabViewData.activeModule)
          node['nodeNotInCurrentlyActiveModule'] = true;
          if (nodeModule == this.tabViewData.activeModule ){
            node['nodeNotInCurrentlyActiveModule'] = false;
          }


          // Here, we prepare EITHER the statistics OR the parameter settings
          // This is depending on the selected data option
          if (this.selectedDataOption == 'statistics'){

            // Assume a single output matrix
            let dataMatrix = currentNode.data;

            let valuesWeStoreForEachTimePeriod = [] // array of arrays; first dimension being time period; contains HTML
            let arrayOfMeans = []


            for (let period = 0; period < dataMatrix.length; period++){

              let mean = Array_Average(dataMatrix[period]);
              let meanAsString = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(mean); // reformat
              valuesWeStoreForEachTimePeriod[period] = [meanAsString];
              csv_row.push(mean);
              arrayOfMeans.push(mean);

            } 

            for (let period = 0; period < valuesWeStoreForEachTimePeriod.length; period++){
              node['nodeData'].push(valuesWeStoreForEachTimePeriod[period]);
              nodeForJSONExport['nodeData'].push(valuesWeStoreForEachTimePeriod[period]);
            }

            // Compute the CAGR-like average groth over all periods for the mean
            let firstValue = arrayOfMeans[0]
            let lastValue = arrayOfMeans[arrayOfMeans.length - 1];
            let numberOfPeriods = arrayOfMeans.length - 1; // if we have two entries, we cover one period
            let cagr = Math.pow(lastValue / firstValue, 1/numberOfPeriods) - 1
            let cagrAsString = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(cagr * 100);
            cagrAsString = cagrAsString.toString() + '%';
            node['nodeAvgGrothRate'] = cagrAsString;

          } else {

            // CASE: Parameter settings
            
            if (currentNode.nodeData.parameters){

              // console.log('predecessorNode', predecessorNode)

              // If the array is shorter than the number of of periods...
              // ...then the user defined a constant ('no change') distribution or one with a fixed growth rate

              // predecessorNode.node.data.parameters is an array of length == 1 or the number of periods
              // each element in the array is an object with potentially multiple key / value pairs

              if ((currentNode.nodeData.parameters.length == 1)){
                // CASE: constant parameters or fixed growth rate
                // This means we only have editable parameters in period 1

                /* 
                  Complication:
                  -------------
                  The parameters array does not get properly reset when switching from individual distributions
                  to constant ('no growth') or fixed growth rate one. It remains the same as before.
                  Thus, we need to get the values from predecessorNode.node.data instead of predecessorNode.node.data.parameters.
                  The problem then is that we have some keys that are not parameters we want to show, such as parameters.
                  We need to exlude them when we list parameters. We do this using includes().
                */

                let whatWePushForFirstPeriod = []

                if (timetype == 'growthrate'){
                  // Then we need to show the growth rate as well

                  let keysToBeIgnored = ['parameters', 'timetype', 'title']

                  let parameterNamesForCSVExport = []
                  let parameterValuesCSVExport = []

                  for (let [key, value] of Object.entries(currentNode.nodeData)) {
                    // console.log(key, value)
                    if (!keysToBeIgnored.includes(key)){
                      whatWePushForFirstPeriod.push({'key': key, 'value': value});
                      parameterNamesForCSVExport.push(key);
                      parameterValuesCSVExport.push(value);
                    }
                  }

                  // fill up until 3 with n/a
                  for (let k = parameterNamesForCSVExport.length; k < maximumNumberOfParametersInAnyNode; k++){
                    parameterNamesForCSVExport.push('n/a')
                    parameterValuesCSVExport.push('n/a');
                  }

                  // Push names to the csv row
                  for (let n = 0; n < parameterNamesForCSVExport.length; n++) {
                    csv_row.push(parameterNamesForCSVExport[n])
                  }

                  // Push values to the csv row; but only for period 0; others are n/a
                  for (let m = 0; m < parameterValuesCSVExport.length; m++) {
                    for (let period = 0; period < this.periods.length; period++){
                      if (period == 0){
                        csv_row.push(parameterValuesCSVExport[m])
                      } else {
                        csv_row.push('n/a')
                      }
                    }
                  }

                } else if (timetype == 'constant'){

                  let keysToBeIgnored = ['parameters', 'timetype', 'growthrate', 'title']

                  let parameterNamesForCSVExport = []
                  let parameterValuesCSVExport = []

                  for (let [key, value] of Object.entries(currentNode.nodeData)) {
                    // console.log(key, value)
                    if (!keysToBeIgnored.includes(key)){
                      whatWePushForFirstPeriod.push({'key': key, 'value': value})
                      parameterNamesForCSVExport.push(key);
                      parameterValuesCSVExport.push(value);
                    }
                  }

                  // fill up until 3 with n/a
                  for (let k = parameterNamesForCSVExport.length; k < maximumNumberOfParametersInAnyNode; k++){
                    parameterNamesForCSVExport.push('n/a')
                    parameterValuesCSVExport.push('n/a');
                  }

                  // Push names to the csv row
                  for (let n = 0; n < parameterNamesForCSVExport.length; n++) {
                    csv_row.push(parameterNamesForCSVExport[n])
                  }

                  // Push values to the csv row; but only for period 0; others are n/a
                  for (let m = 0; m < parameterValuesCSVExport.length; m++) {
                    for (let period = 0; period < this.periods.length; period++){
                      if (period == 0){
                        csv_row.push(parameterValuesCSVExport[m])
                      } else {
                        csv_row.push('n/a')
                      }
                    }
                  }

                }

                node['nodeParameters'].push(whatWePushForFirstPeriod)

                for (let i = 1; i < this.periods.length; i++){
                  // Fill the remainder for all other periods with empty strings

                  node['nodeParameters'].push({})
                  nodeForJSONExport['nodeParameters'].push("")
                
                }
              } else {

                // CASE: We have parameter settings explicitly defined for each period
                // Then we can use the parameters array

                let parameterNamesForCSVExport = []
                let parameterValuesCSVExportInterim = [] // array of periods, then array for keys
                
                // console.log('parameters for node ' + label, predecessorNode.node.data.parameters)
                for (let period = 0; period < this.periods.length; period++){
                  let whatWePushForEachPeriod = [];
                  let valueArrayForEachPeriod = [];
                  // Iterate over the keys in the object for this time period
                  for (let [key, value] of Object.entries(currentNode.nodeData.parameters[period])) {
                    // console.log(value)
                    if (period == 0){
                      // Write names into CSV row (but only once; not for every period)
                      parameterNamesForCSVExport.push(key)
                    }
                    whatWePushForEachPeriod.push({'key': key, 'value': value})
                    valueArrayForEachPeriod.push(value)
                  }
                  node['nodeParameters'].push(whatWePushForEachPeriod)
                  parameterValuesCSVExportInterim.push(valueArrayForEachPeriod)
                }

                // fill up until 3 with n/a
                for (let k = Object.entries(currentNode.nodeData.parameters[0]).length; k < maximumNumberOfParametersInAnyNode; k++){
                  parameterNamesForCSVExport.push('n/a')
                }
                
                // Push parameter names to CSV row
                for (let i = 0; i < parameterNamesForCSVExport.length; i++){
                  csv_row.push(parameterNamesForCSVExport[i]);
                }

                // console.log('parameterNamesForCSVExport', parameterNamesForCSVExport)

                // Push parameter values to CSV row
                for (let j = 0; j < Object.entries(currentNode.nodeData.parameters[0]).length; j++){ // the number of parameters we have
                  for (let period = 0; period < this.periods.length; period++){
                      csv_row.push(parameterValuesCSVExportInterim[period][j])
                  }
                }

                // fill up remaining values for parameters with n/a
                for (let l = 0; l < maximumNumberOfParametersInAnyNode - Object.entries(currentNode.nodeData.parameters[0]).length; l++ ){
                  for (let period = 0; period < this.periods.length; period++){
                    csv_row.push('n/a');
                  }
                }


              }
            
            } else {

              for (let i = 0; i < this.periods.length; i++){
                node['nodeParameters'].push({}) // empty
              }

              for (let i = 0; i < this.periods.length * maximumNumberOfParametersInAnyNode; i++){
                csv_row.push('n/a');
              }

            }
            
          }


          // Now create subtrees for all predecessors
          currentNode.predecessors.forEach(function(predecessorNodeUUID) {
            let subtree = makeTree(predecessorNodeUUID);

            // Test if we received an empty object; if we do NOT, then add tree
            // Add 'nodes' key and value if it does not exist yet so we can push entries
            if (!(Object.keys(subtree).length === 0 && subtree.constructor === Object)){
              if (!('nodes' in node)){
                node['nodes'] = [];
              }
              node['nodes'].push(subtree)
            }

          });

          CSVReadyArrayOfArrays.push(csv_row)

          return node          

        }

        nodesWithoutSuccessors.forEach(function(endNodeUUID){
          
          let subtree = makeTree(endNodeUUID);
          self.trees.push(subtree)

        });

        let csvContent = "";
        
        CSVReadyArrayOfArrays.forEach(function(rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });

        this.treesAsCSVReadyArrayOfRows = csvContent

                
      }
    }
  }

</script>


<style scoped>

/* Scrollbar */

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

/* Popup Box */
  
  #tabViewPopupBox {
    z-index: 100;
  }

  /* mPopup box style */
  .tabViewPopup {
    position: fixed;
    z-index: 1;
    padding-top: 50px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    /* overflow: -moz-scrollbars-vertical; */
  }

  .tabView-popup-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    width: 90%;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  .tabView-popup-header {
    padding: 2px 16px;
    background-color: #51A7DD;
    color: white;
  }

  .tabView-popup-main {
    /* This is the part of the pop-up underneath the pop-up header */

    padding: 10px 16px;
    overflow:auto;

  }

    /* close button style */
  .tabView_close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  .tabView_close:hover, .tabView_close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .tableHeader {
    display: flex;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 20px;
    border-bottom: 2px solid #ccc;
    line-height: 2em;

  }

  .menuBar {
    display: flex;
    align-items: center; /* y axis alignment */
    margin-bottom: 10px;
    margin-top: 10px;

  }

  .downloadOptions {
    display: flex;
    justify-content: flex-end; /* x axis alignment */
  }

  .downloadOptions button {
    height: 30px;
    margin-right: 10px;
  }



</style>
